// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3GW_d","footer":"ModalFilter_footer__3_xMU"};